import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Helper from '../../Helper';
import Alert from '../sub/dialog';
import moment from 'moment';
import './Bill.css'; // Import CSS for print styling
import './Tawi.css'; // Import CSS for print styling
import PrintHeader from './sub/PrintHeaderExpense';
import PrintFooter from './sub/PrintFooterExpense';
import { Previewer } from 'pagedjs';
import { MDBTable, MDBTableHead, MDBTableBody, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import { height } from '@mui/system';


const TransportPrint = ({ data }) => {
    const navigate = useNavigate();

    const [company, setCompany] = useState({
        name: '',
        name_en: '',
        address: '',
        phone: '',
        email: '',
        website: '',
        taxid: '', bankaccount: '', bankaccountname: '', bankname: '', bankaccounttype: ''

    });

    const [userinfo, setUserinfo] = useState({});
    const [customer, setCustomer] = useState({});
    const alert = useRef();
    const printRef = useRef();
    let { name, type } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isPersonal, setIsPersonal] = useState(searchParams.get("personal") == "1");
    const [summarydata, setSummarydata] = useState({});
    const [transportAccount, setTransportAccount] = useState({});
    const [transportJobList, setTransportJobList] = useState([]);
    const setError = (message) => alert.current.showerror(message);
    const header = { name: "บันทึกค่าใช้จ่าย" }
    const handlePrint = useReactToPrint({
        documentTitle: header.name,
        contentRef: printRef,
    });

    const wideSpaceIndexes = [0, (0 + 4), (0 + 4 + 5), (0 + 4 + 5 + 2)];
    const getTransportAccount = async (transportname) => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccount_expense/${transportname}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (!data.transportAccount) {
                    setError('ไม่มีข้อมูลการขนส่ง');
                    return;
                }

                setSummarydata({
                    totalamount: data.transportAccount.totalamount,
                    totalnetamount: data.transportAccount.totalnetamount,
                    totalvatamount: data.transportAccount.totalvatamount,
                    totalwhtamount: data.transportAccount.totalwhtamount,
                    totalpaidamount: data.transportAccount.totalpaidamount
                });
                setTransportAccount(data.transportAccount);
                fetchCustomer(data.transportAccount.customerid);
                fetchuser(data.transportAccount.modify_user);
                setTransportJobList(data.expense);

            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch transport list');
            }
        } catch (err) {
            setError('An error occurred while fetching the transport list.');
        }
    }



    const fetchCustomer = async (customerid) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Getcustomerbyid/${customerid}`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data && data.customer) setCustomer(data.customer);
        } catch (error) {
            setError('Error fetching customer profile:', error);
        }
    };
    const fetchuser = async (username) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Getuserinfo/${username}`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data && data.userinfo) setUserinfo(data.userinfo);
        } catch (error) {
            setError('Error fetching customer profile:', error);
        }
    };
    const fetchCompany = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetcompanyProfile`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data) setCompany(data);
        } catch (error) {
            setError('Error fetching company profile:', error);
        }
    };



    useEffect(() => {
        // Get the token from sessionStorage


        if (!["account", "billing", "admin"].includes(Helper.getuserrole())) {
            navigate('/main');
            return;
        }
        if (!name) {
            navigate('/main');
            return;
        }
        fetchCompany();
        getTransportAccount(name);

        // Initialize Paged.js preview after all data is loaded

    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', flexDirection: 'column' }}>
            <style type="text/css" media="print">{"\
  @page {\ size:A4\ }\
"}</style>
            <Alert ref={alert} />
            <button className='btn btn-info mb-4 mt-4' onClick={handlePrint}>Print</button>

            <div ref={printRef} className="bill tawi print-container"  >



                <div className='print-page' style={{ backgroundImage: "url(/WhtCertificate.svg)" }}>
                    <div style={{ zoom: 0.8 }}>
                        <MDBRow className='me-1' >
                            <MDBCol size='4' className='offset-8' style={{ textAlign: "right" }} >
                                REF#1{transportAccount.name}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='receiptname'>
                            <MDBCol md='12' style={{ textAlign: "right" }} >
                                {transportAccount.receiptname}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='company taxid'>
                            <MDBCol md='12' style={{ textAlign: "right" }} >
                                {company.taxid.split("(")[0].split("").map((digit, index) => {

                                    const spaceClass = wideSpaceIndexes.includes(index) ? 'space-2' : 'space-1';
                                    return (<span key={index} className={`digit ${spaceClass}`}>{digit}</span>)

                                })}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='companyname ms-4'>
                            <MDBCol md='12'>
                                {company.name}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='companyaddress ms-4 mt-3 ps-2'>
                            <MDBCol md='12'>
                                {company.address}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='customer taxid'>
                            <MDBCol md='12' style={{ textAlign: "right", minHeight: "1.6em" }} >
                                {customer.tax?.split("(")[0]?.split("").map((digit, index) => {

                                    const spaceClass = wideSpaceIndexes.includes(index) ? 'space-2' : 'space-1';
                                    return (<span key={index} className={`digit ${spaceClass}`}>{digit}</span>)

                                })}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='customername ms-4'>
                            <MDBCol md='12'>
                                {customer.name}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='customeraddress ms-4 mt-3 ps-2 pt-1'  style={{minHeight: "1.9em" }}>
                            <MDBCol md='12' className=''>
                               <span style={{ zoom: 0.9, paddingTop: "5px"}}>{customer.address}</span>
                            </MDBCol>
                        </MDBRow>
                        {isPersonal ?
                            <MDBRow className='mt-2 pt-3'>
                                <MDBCol className='col-1 offset-8 tax53'  style={{ paddingLeft: "140px" }}>
                                    <MDBIcon fas icon="check" />
                                </MDBCol>
                            </MDBRow>
                            :
                            <MDBRow className='mt-5 pt-2'>
                                <MDBCol className='col-1 offset-8 tax53'>
                                    <MDBIcon fas icon="check" />
                                </MDBCol>
                            </MDBRow>
                        }
                        <MDBRow className='taxdetail'>
                            <MDBCol md='12'>
                                <div> รางวัล ส่วนลดหรือประโยชน์ใด ๆ เนื่องจากการส่งเสริมการขาย รางวัลในการประกวด การแข่งขัน การชิงโชค คำแสดงของนักแสดงสาธารณะ ค่าจ้างทำของ ค่าโฆษณา ค่าเช่า ค่าขนส่ง ค่าบริการ ค่าเบี้ยประกันวินาศภัย ฯลฯ</div>
                            </MDBCol>
                        </MDBRow>
                        <div className='transportAccount' style={{ textAlign: "right" }}>
                            <MDBRow >

                                <MDBCol size='2' className='offset-5' style={{ paddingLeft: "110px" }} >
                                    {moment(transportAccount.billdateobj).format("DD/MM/YYYY")}
                                </MDBCol>
                                <MDBCol size='2' style={{ marginLeft: "26px" }}>
                                    {Helper.formatnumber(transportAccount.totalnetamount)}
                                </MDBCol>
                                <MDBCol size='2' style={{ marginLeft: "-51px" }}>
                                    {Helper.formatnumber(transportAccount.totalwhtamount)}
                                </MDBCol>
                            </MDBRow>
                            <div style={{ height: "95px" }}></div>
                            <MDBRow >

                                <MDBCol size='2' className='offset-5' style={{ paddingLeft: "110px" }} >

                                </MDBCol>
                                <MDBCol size='2' style={{ marginLeft: "26px" }}>
                                    {Helper.formatnumber(transportAccount.totalnetamount)}
                                </MDBCol>
                                <MDBCol size='2' style={{ marginLeft: "-51px" }}>
                                    {Helper.formatnumber(transportAccount.totalwhtamount)}
                                </MDBCol>
                            </MDBRow>
                            <div style={{ height: "15px" }}></div>
                            <MDBRow ><MDBCol size='9' className='offset-3' style={{ textAlign: "left" }}>
                                {Helper.BAHTTEXT(transportAccount.totalwhtamount)}
                            </MDBCol>
                            </MDBRow>
                            <div style={{ height: "9px" }}></div>
                            <MDBRow >
                                <MDBCol size='2' className='offset-3' style={{ paddingLeft: "110px" }} >
                                    0.00
                                </MDBCol>
                                <MDBCol size='2' style={{ marginLeft: "43px" }}>
                                    0.00
                                </MDBCol>
                                <MDBCol size='2' style={{ marginLeft: "55px" }}>
                                    0.00
                                </MDBCol>
                            </MDBRow>
                            <div style={{ height: "11px" }}></div>
                            <MDBRow ><MDBCol size='1' className='offset-1' style={{ textAlign: "left", paddingLeft: "18px" }}>
                                <MDBIcon fas icon="check" />
                            </MDBCol>
                            </MDBRow>
                            <div style={{ height: "50px" }}></div>
                            <MDBRow >
                                <MDBCol size='3' className='offset-6' style={{ textAlign: "left", paddingLeft: "40px", verticalAlign: "bottom" }} >
                                    {moment(transportAccount.billdateobj).format("DD/MMM/YYYY").split("/").map((digit, index) => {
                                        return (<span key={index} className={`margindate`}>{digit}</span>)

                                    })}
                                </MDBCol>
                                <MDBCol md='3'>
                                    <div className='companystamp'><img src="/stamp.png" alt="Company Stamp" style={{ width: 'auto', height: '100px' }} /></div>
                                </MDBCol>
                            </MDBRow>
                        </div>
                    </div>
                </div>

            </div>
        </div >
    );
};

export default TransportPrint;